import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "country"]

  handleCountryUpdate(event) {
    const target = event.target
    const indexOfNextSelect = this.countryTargets.indexOf(target) + 1
    const countrySelectToUpdate = this.countryTargets[indexOfNextSelect]
    if (!countrySelectToUpdate) { return }

    const nameInputHasNoValue = this.nameTargets.some((nameInput) => {
      return nameInput.id === countrySelectToUpdate.dataset.siteId && nameInput.value.length === 0
    })
    if (!nameInputHasNoValue) { return }

    countrySelectToUpdate.value = target.value
  }
}
